export default {
  identityInformation: {
    title: "Identity Information",
    rejectReason: "Reason for Identity Verification Rejection:",
    quickVerification:
      "If you want to verify your identity faster, we suggest using the app.",
    quickVerificationButton: "Got it",
    getOTP: "Get Verification Code",
    submitButton: "Continue",
    personalStatus: {
      verified: "Your identity verification is fully completed",
      progress: {
        title: "Your identity verification is not complete",
        subtitle:
          "By completing your identity verification, you can deposit and withdraw Rial.",
        steps: {
          contactInfo: "Contact Information",
          personalInfo: "Personal Information",
          identityInfo: "Identity Verification",
          internationalCardImage: "National ID Photo",
          confirmKyc: "Confirm Identity Verification"
        }
      }
    },
    contactInfo: {
      headerTitle: "Contact Information Verification",
      title: "Contact Information",
      mobile: {
        title: "Mobile Number",
        verified: "Verified",
        unverified: "Unverified",
        verifyMobileButton: "Verify Mobile Number*",
        submitButton: "Submit",
        validations: {
          emptyPassword: "Enter password",
          invalidCode: "Invalid SMS code",
          emptyCode: "Enter the SMS code"
        },
        modals: {
          getMobileNumber: {
            title: "Verify Mobile Number",
            subtitle: "Enter your mobile number",
            inputLabel: "Mobile Number",
            inputExample: "e.g., 09123456789",
            submitButton: "Continue",
            mobileValidation: {
              invalid: "Invalid mobile number"
            }
          },
          getVerificationCode: {
            title: "Enter the code sent to {n}.",
            inputPlaceholder: "SMS Code",
            getVerificationCodeAgainButton: "Resend Verification Code",
            getVerificationCodeAgainTitle: "Resend code in",
            getVerificationCodeAgainSecondsTitle: "seconds",
            submitButton: "Confirm",
            previousStep: "Previous Step"
          }
        }
      },
      phone: {
        title: "Phone Number",
        verified: "Verified",
        unverified: "Unverified",
        verifyPhoneButton: "Verify Phone Number",
        submitButton: "Submit",
        phoneValidation: {
          invalid: "Invalid phone number",
          empty: "Enter phone number"
        },
        modals: {
          getPhoneNumber: {
            title: "Verify Phone Number",
            subtitle: "Enter your Phone number with the city code",
            inputLabel: "Phone Number",
            submitButton: "Continue",
            inputExample: "e.g., 02123456789"
          },
          getVerificationCode: {
            title:
              "Enter the 6-digit code read to you via a phone call to ({n}) in the box below",
            inputPlaceholder: "Received Code",
            getVerificationCodeAgainButton: "Resend Verification Code",
            getVerificationCodeAgainTitle: "Resend code in",
            getVerificationCodeAgainSecondsTitle: "seconds",
            submitButton: "Confirm",
            previousStep: "Previous Step"
          }
        }
      },
      email: {
        title: "Email",
        verified: "Verified",
        unverified: "Unverified",
        verifyEmailButton: "Verify Email",
        submitButton: "Submit",
        emailValidation: {
          invalid: "Invalid email",
          empty: "Enter email"
        },
        modals: {
          getEmail: {
            title: "Verify Email Address",
            subtitle: "Enter your email",
            inputLabel: "Email",
            submitButton: "Continue",
            inputExample: "e.g., user@gmail.com"
          },
          getVerificationCode: {
            title: "Click 'Get Code' to receive the verification code",
            inputPlaceholder: "Email Verification Code",
            getVerificationCodeAgainButton: "Get Code",
            getVerificationCodeAgainTitle: "Resend code in",
            getVerificationCodeAgainSecondsTitle: "seconds",
            submitButton: "Confirm",
            previousStep: "Previous Step"
          }
        }
      }
    },
    personalInformation: {
      title: "Personal Information",
      verified: "Verified",
      pending: "Pending",
      edit: "Edit",
      submit: "Submit",
      fullName: "Full Name",
      nationalCode: "National ID",
      dateOfBirth: "Date of Birth",
      authUnavailable:
        "Identity verification service is temporarily unavailable. Please try again later.",
      pictureVerify: {
        title: "Identity Verification Photo",
        validation: {
          part1: "To upload an identity verification photo, first complete the",
          part2: "Personal Information section"
        }
      },
      modals: {
        getPersonalInfo: {
          title: "Enter Personal Information",
          subtitle:
            "Enter your personal information according to your identification document",
          firstNameLabel: "First Name",
          lastNameLabel: "Last Name",
          nationalCodeLabel: "National ID",
          dateLabel: "Date of Birth",
          submitButton: "Submit",
          typeOfUser: "User Type"
        }
      },
      validation: {
        noValid: "Invalid",
        firstNameRequired: "is required",
        firstNamePersianRequired: "Enter your first name in Persian",
        lastNameRequired: "Last name is required",
        lastNamePersianRequired: "Enter your last name in Persian",
        birthDayRequired: "Date of birth is required",
        nationalCodeRequired: "National ID is required",
        nationalCodeValidation: "Invalid National ID"
      },
      hints: {
        firstName: "First name in Persian as per National ID",
        lastName: "Last name exactly as per National ID",
        nationalCode: "e.g., 0011283927"
      }
    },
    personalPicture: {
      title: "Identity Verification",
      hasIdentityTitle:
        "To upload an identity verification photo, first complete both the Contact Information and Personal Information sections",
      isPendingTitle:
        "The identity verification photo process may take some time. Thank you for your patience.",
      verified: "Verified",
      pending: "Pending",
      submit: "Submit",
      modals: {
        getPersonalPicture: {
          title: "Identity Verification Photo",
          subtitle:
            "To verify your identity, upload a photo as per the sample and the requested items in the description",
          uploadButton: "Upload",
          uploadInputFile: "Upload Identity Verification Photo",
          uploadGuideLine: "Identity Verification Photo Upload Guide",
          guideLineParagraph:
            "In the uploaded photo, hold your original smart National ID along with a handwritten note with the text below next to your face.",
          textTitle: "Note Text",
          mainText:
            "I have read and accepted all the rules of Excoino and take responsibility for my transactions. I commit not to give my user account and bank card to anyone else and have no objections to the site rules.",
          dateAndSignature: "Date and Signature",
          guideLineParagraph2:
            "Adjust the photo frame to clearly show that you are holding the documents.",
          guideLineParagraph3:
            "The note text, identification document, and entire photo must be clear without any blur or effect.",
          guideLineParagraph4:
            "The photo size should be between 100 KB and 10 MB.",
          takingPictureGuideLine: "Sample Photo",
          validFormatsTitle: "Allowed file formats:",
          invalidFormatFiles: "Invalid file format.",
          minFileSizeValidation: "The file size must be at least 100 KB.",
          maxFileSizeValidation: "The file size must not exceed 10 MB."
        }
      }
    },
    autoVerification: {
      title: "Identity Verification",
      isRejectTitle:
        "Your identity verification was not approved. To reattempt, please use the app.",
      changeIdentificationMethod: "change identification method",
      orManual1: "or use",
      orManual2: "instead.",
      manualIdentification: "Manual Identity Verification",
      verified: "Verified",
      pending: "Pending",
      unverified: "Unverified",
      submit: "Submit",
      modals: {
        changeIdentificationMethod: {
          title: "Change Identity Verification Method",
          subtitle:
            "Are you sure you want to switch to 'Manual Identity Verification'? Confirming will cancel the 'Quick Identity Verification' process.",
          confirmButton: "Confirm",
          cancelButton: "Cancel"
        }
      }
    },
    internationalCard: {
      headerTitle: "Verify and Review National ID",
      headerDescription:
        "Verify or edit the information and photo of your National ID if there is any discrepancy.",
      internationalCardGuidTitle: "National ID Photo Guide",
      internationalCardGuidText: "Must be read"
    }
  },
  bankInformation: {
    title: "Bank Information",
    bankCards: {
      title: "Bank Cards",
      addCardsButton: "Add New Card",
      empty: "No bank cards registered",
      modals: {
        addCards: {
          title: "Add New Bank Card",
          subtitle: "Ensure that the card you register is in your name.",
          cardLabel: "Card Number",
          invalidInputCard: "Invalid card number",
          emptyInputCard: "Enter card number",
          addCardButton: "Verify and Add Card"
        },
        deleteCard: {
          title: "Delete Card Number",
          subtitle: "Are you sure you want to delete this card number?",
          deleteButton: "Yes, delete it",
          cancelButton: "Cancel"
        }
      }
    },
    shebaCards: {
      title: "Sheba Addresses",
      addCardsButton: "Add Sheba Address",
      empty: "No Sheba addresses registered",
      modals: {
        addCards: {
          title: "Add Sheba Number",
          subtitle:
            "Ensure that the Sheba number you register is in your name.",
          titleInputLabel: "Title",
          shebaInputLabel: "Sheba Number",
          emptyTitleInputCard: "Enter title",
          invalidShebaInputCard: "Invalid Sheba number",
          emptyShebaInputCard: "Enter Sheba number",
          addCardButton: "Verify and Add Sheba Number"
        },
        deleteCard: {
          title: "Delete Sheba Number",
          subtitle: "Are you sure you want to delete this Sheba number?",
          deleteButton: "Delete",
          cancelButton: "Cancel"
        }
      }
    }
  },
  security: {
    title: "Account Security",
    change: "Change",
    delete: "Remove",
    twoFactorAuth: {
      title: "Security Factors",
      subtitle:
        "To enhance the security of your assets (during withdrawal, purchase, etc.), we recommend enabling two-factor authentication.",
      SMSAuthentication: {
        title: "Mobile Authentication",
        defaultRadioButton: "Default",
        inactiveButton: "Deactivate",
        activeButton: "Activate"
      },
      emailAuthentication: {
        title: "Email Authentication",
        defaultRadioButton: "Default",
        inactiveButton: "Deactivate",
        activeButton: "Activate"
      },
      googleAuthenticator: {
        title: "Google Authenticator",
        defaultRadioButton: "Default",
        inactiveButton: "Deactivate",
        activeButton: "Activate"
      },
      activeAuthenticator: {
        title: "Two-Factor Authentication (2FA)",
        defaultTitle: "Default",
        defaultItems: {
          sms: "With Mobile",
          email: "With Email",
          google2fa: "With Google Authenticator"
        },
        inactiveButton: "Deactivate",
        activeButton: "Activate"
      },
      loginWith2fa: {
        title: "Two-Factor Authentication (2FA)",
        subtitle:
          "To enhance the security of your assets (during withdrawal, purchase, etc.), we recommend enabling two-factor authentication.",
        inactiveButton: "Deactivate",
        items: [
          {
            title: "With Mobile",
            value: "sms"
          },
          {
            title: "With Email",
            value: "email"
          },
          {
            title: "With Google Authentication",
            value: "google2fa"
          }
        ],
        hints: {
          mobile:
            "To activate two-factor authentication with mobile, please first register and verify your mobile.",
          email:
            "To activate two-factor authentication with email, please first register and verify your email.",
          google2fa:
            "To activate two-factor authentication with Google (Google Authentication), please first enable Google Authentication."
        }
      },
      modals: {
        activeDetails: {
          title: "Two-Factor Authentication",
          subtitle: "Click 'Get Code' to receive the verification code",
          getCodeButton: "Get Code"
        },
        activeEmail: {
          codeLabel: "Email Verification Code"
        },
        activeGoogle: {
          codeLabel: "Google Verification Code",
          title: "Google Authentication",
          continue: "Continue",
          stepper: [
            {
              id: 1,
              name: "Select Method",
              icon: "$downloadSaveUpload"
            },
            {
              id: 2,
              name: "Generate Code",
              icon: "$qrCode"
            },
            {
              id: 3,
              name: "Activation",
              icon: "$doneCheck"
            }
          ],
          step1: {
            title: "Download the App",
            description: "You can install the Google Authenticator app on Android and iOS platforms using the link below.",
            getApp: "Get it from",
            guid: "Visual guide for installing and using the app",
        
            activeAuto: {
              title: "Automatic Mode (Recommended)",
              description: "To enable Google verification code automatically in the Google Authenticator app, use this method.",
              button: "Activate Automatically",
              warning: "This mode is only available in the mobile application."
            },
        
            activeManual: {
              title: "Manual Mode",
              description: "If the Google verification code is not activated automatically, use the manual method to activate it.",
              guid: "Visual guide for manual activation of Google verification",
              button: "Activate Manually"
            },
        
            nextStepButton: "Next Step"
          },
        
          step2: {
            description: "Scan this QR Code in the Google Authenticator app or manually enter the code below into the app.",
            warning: "Make sure to note down the code below somewhere safe.",
            copy: "Successfully copied.",
        
            guidSlider: {
              title: "Adding Code in Google Authenticator",
              desc1: "You need to manually add the 16-digit Google code provided in the previous step into the Google Authenticator app. You can use the guide below.",
              desc2: "After opening the app, select 'Add an account'.",
              desc3: "Then choose 'Enter a setup key'.",
              desc4: "In the 'Code Name' field, enter a name for your code, then paste the setup key into the 'Your key' field. The key type should be set to 'Time based'.",
              desc5: "This 6-digit code is generated for your current account and will become active after completing the activation steps. Note that this one-time code changes every 30 seconds."
            }
          },
        
          step3: {
            title: "Activate the Code",
            description: "Enter the 6-digit Google code (Google Authenticator)",
            warning: "If you're entering the correct 6-digit code but still getting an error, check if your device's date and time settings are set to Automatic.",
            googleLabel: "Enter the 6-digit Google code",
            passwordLabel: "Excoino account password",
            emptyGoogleAuth: "Enter the 6-digit Google code",
            emptyPassword: "Enter your Excoino password"
          }
        },
        inactiveModal: {
          title: "Deactivate Two-Factor Authentication (2FA)",
          warning:
            "Deactivating two-factor authentication will make your account more vulnerable to unauthorized access. It is recommended to re-enable it as soon as possible.",
          passwordTitle: "Enter your password",
          passwordLabel: "Password",
          emptyPassword: "Enter your password",
          submitButton: "Confirm"
        },
        activeSMS: {
          codeLabel: "Mobile Verification Code",
          step1: {
            title: "Verify Mobile Number",
            subtitle: "Enter your mobile number",
            warning:
              "Note: The mobile number you enter will be considered your primary mobile number and cannot be edited.",
            mobileLabel: "Mobile Number",
            mobileHint: "e.g., 09123456789",
            nextStepButton: "Continue"
          },
          step2: {
            title: "Activate SMS Authentication",
            subtitle: "Please enter the code sent to ({n}).",
            codeLabel: "SMS Code",
            resendCodeButton: "Resend Verification Code",
            counterTitle: {
              part1: "Resend code in",
              part2: "seconds"
            },
            passwordTitle: "Enter your password",
            passwordLabel: "Password",
            submitButton: "Confirm",
            previousStepButton: "Previous Step"
          }
        },
        inactiveSMS: {
          title: "Deactivate SMS Authentication",
          warning:
            "Deactivating two-factor authentication will make your account more vulnerable to unauthorized access. It is recommended to re-enable it as soon as possible. After deactivation, if unusual activity is detected, you may not be able to withdraw Rial and crypto for 24 hours.",
          passwordTitle: "Enter your password to deactivate SMS authentication",
          passwordLabel: "Password",
          emptyPassword: "Enter your password",
          submitButton: "Confirm"
        }
      }
    },
    username: {
      title: "Username",
      submitButton: "Submit",
      modals: {
        addUsername: {
          title: "Add Username",
          warning:
            "Note: The username you choose cannot be changed. Please choose carefully.",
          usernameLabel: "Username",
          usernameHints: {
            title: "Username must:",
            item1: "Be between 4 and 32 characters.",
            item2: "Contain only English letters"
          },
          submitButton: "Confirm"
        }
      }
    },
    password: {
      title: "Password",
      changeButton: "Edit",
      modals: {
        changePassword: {
          title: "Edit Password",
          currentPasswordLabel: "Current Password",
          emptyPassword: "Enter current password",
          newPasswordLabel: "New Password",
          emptyNewPassword: "Enter new password",
          passwordHint: "Password must:",
          confirmNewPasswordLabel: "Confirm New Password",
          emptyConfirmNewPassword: "Enter new password confirmation",
          submitButton: "Confirm"
        }
      }
    },
    securityTwoFactorAuth: {
      watchVideoText: "Watch Tutorial Video",
      closeBtn: "Close",
      watchGoogleGuid:
        "Watch the complete Google Authenticator activation guide"
    },
    modals: {
  numberChange: {
    title: "Change Mobile Number",
    newNumber: "New Mobile Number",
    confirmationCode: "New Mobile Verification Code",
    warning: "Dear user, to protect your assets and account, after changing the mobile number, any withdrawal from the account will be disabled for 24 hours.",
  },
  emailChange: {
    title: "Change Email",
    newEmail: "New Email",
    confirmationCode: "New Email Verification Code",
    warning: "Dear user, to protect your assets and account, after changing the email, any withdrawal from the account will be disabled for 24 hours.",
  },
  removeGoogleAuth: {
    title: "Remove Authenticator",
    otpCode: "Code sent to Email or Mobile",
    warning: "Dear user, to protect your assets and account, after removing Google Authenticator, any withdrawal from the account will be disabled for 24 hours.",
  },
  password: "Account Password",
  googleAuth: "Google Authenticator",
  confirm: "Confirm",
  getCode: "Get Code",
  activate: "Activate",
  codeSent: "Verification code sent successfully."
}
  },
  accountSidebar: {
    unverified: "Unverified",
    completeVerification: "Complete Verification",
    totalAssets: "Total Asset Value",
    profitLoss: "Total Profit (Loss)",
    links: {
      identity: {
        title: "Identity Information",
        label: "Complete Verification",
        description: "Complete, view, and edit identity information"
      },
      bankInformation: {
        title: "Bank Information",
        label: "",
        description: "Manage Sheba numbers and bank cards"
      },
      security: {
        title: "Security",
        label: "",
        description: "Manage password, 2FA, username"
      },
      referral: {
        title: "Referral",
        label: "",
        description: "Invite your friends and get rewards"
      },
      gifts: {
        title: "Gifts",
        label: "",
        description: "Account balance bonuses and festivals"
      },
      ticketing: {
        title: "Tickets",
        label: "",
        description: "Support tickets list"
      }
    },
    signOutButton: "Sign Out",
    referralCard: {
      introduceToFriends: "Refer to Friends",
      inviteGetExcoin: "Invite friends, get Excoin",
      referralCode: "Referral Code",
      referralCodeCopied: "Referral code copied"
    }
  },
  level: {
    title: "User Levels",
    accountLevelText: "You are a {level} user",
    enterToLevelBtn: "Enter this level",
    unlimitedText: "Unlimited",
    descriptionText: "Description"
  },
  kyc: {
    checkText: "Your information is being reviewed",
    checkText2:
      "After reviewing and approving the information, your identity verification will be completed and you will be notified via SMS",
    autoKyc: {
      internationalCard: {
        guidTitle: "National ID Photo Guide",
        originalImageText: "Take a photo of your original National ID.",
        bgImageText:
          "The background on which the National ID is placed should be single-colored.",
        clearImageText: "The photo should be clear and identifiable.",
        blackAndWhiteImageText: "The photo should not be black and white.",
        notValidImageText: "The National ID should not be old or expired.",
        receiveInformationText: "We are retrieving your information",
        delayText: "It may take a few seconds",
        uploadCard: {
          onTheCardTitle: "Select Front Side of National ID Photo",
          backTheCardTitle: "Select Back Side of National ID Photo"
        }
      },
      kycTypeSelection: {
        disableKyc: "Currently, the authentication system is not available",
        fillText: "Please complete your identity verification",
        accessToCompleteText:
          "To complete your identity verification, you need access to your smart National ID.",
        fastRecognize: "Quick Identity Verification",
        recognizeIn10Sec: "Identity Verification in 10 Minutes",
        inFastRecognize: "In quick",
        recordVideoText: "You need to record a video of yourself.",
        autoProccessText: "The review process is automated.",
        startFastRecongnize: "Start Quick",
        normalRecognize: "Manual Identity Verification",
        recognizeIn10Min: "Identity Verification in 2 Hours",
        inNormalRecognize: "In manual identity verification",
        uploadImageText: "You need to take or upload a photo of yourself.",
        supportCheckProsseccText:
          "The review process is carried out by the support team.",
        startNormalRecongnize: "Start Manual Identity Verification",
        confidentionalInfoText:
          "The information you provide during identity verification is used solely for identification purposes and is kept confidential by Excoino."
      },
      videoGuid: {
        recognizeVideoTitle: "Identity Verification Video",
        toStartRecording:
          "To start, look at the camera and follow the on-screen instructions.",
        importantPoints: "Important Points",
        islamicPrinciplesText: "Observe Islamic principles.",
        fullFaceText: "Ensure your entire face is visible in the frame.",
        checkMicText: "Check your lighting and microphone.",
        readText: "Read the displayed text clearly and loudly.",
        avoidHatText: "Do not wear a hat.",
        avoidEffectText: "Do not use any effects on the video.",
        clickRecordAndRead:
          "Click the record video button and read the text below clearly and loudly:",
        acceptTerms:
          "To verify identity on Excoino, I have read the rules and accept responsibility for all transactions from my account. I do not give my user account and bank card to another person.",
        watchVideo: "View Recorded Video",
        recordVideoTitle: "Record Video",
        stopVideoTitle: "Stop",
        recordAgainText: "Record Video Again",
        acceptAndContinue: "Confirm and Continue",
        gettingDataText: "We are retrieving your data",
        delayText: "It may take a few seconds"
      }
    },
    manualKyc: {
      imageSelectionTitle: "Select Identity Verification Photo",
      takePhotoTitle: "Take Photo with Camera",
      takePhoto: {
        acceptPreviousConditionsText:
          "Follow the conditions stated in the previous section and click the take photo button.",
        checkTakenPhotoText:
          "Review the taken photo and if it meets the conditions, click the confirm and continue button.",
        blockedUsingCameraText: "You have blocked camera access",
        activeUsingCameraText:
          "If desired, enable camera access from your browser settings",
        takePhotoTitle: "Take Photo",
        takePhotoAgainBtn: "Take Photo Again",
        acceptAndContinue: "Confirm and Continue"
      }
    },
    noWebcam: {
      doNotHaveWebcamText: "My device does not have a webcam",
      continueIfDoNotHaveWebcamText:
        "If you do not have access to a webcam, you can continue the identity verification process on the Excoino app",
      fastRecognizeTitle: "Quick Identity Verification",
      useExcoinoToRecognize:
        "To continue the identity verification process, you can use the Excoino app",
      scanToDownoalBtn: "Scan to download",
      normalRecognizeTitle: "Manual Identity Verification",
      inNormalRecognizeText: "In manual identity verification",
      uploadPhotoText: "You need to upload a photo of yourself.",
      checkBySupportText:
        "The review process is carried out by the support team.",
      startNormalRecognizeBtn: "Start Manual Identity Verification"
    }
  },
  personal: {
    autoVerification: {
      identificationText: "Verification"
    },
    persoanlKycStatus: {
      identificationText: "Verification"
    }
  }
};
